import { render, staticRenderFns } from "./ReviewsList.vue?vue&type=template&id=5bf7bfa5"
import script from "./ReviewsList.vue?vue&type=script&lang=js"
export * from "./ReviewsList.vue?vue&type=script&lang=js"
import style0 from "./ReviewsList.vue?vue&type=style&index=0&id=5bf7bfa5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports